import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import Button from '../common/inputs/button';
import Constants from '../../../definitions/constants';

const GenerateButton = props => {
  const {
    loadingGenerate,
    handleGenerate,
    generateDisabled
  } = props;
  return (
    <div className="generate_section generate_button_wrapper">
      <Button
        disabled={loadingGenerate || generateDisabled}
        loading={loadingGenerate}
        onClick={handleGenerate}
        labelLocale={<FormattedMessage id="reportFileAdmin.generateButtonTitle"/>}
      />
    </div>
  );
};

export default GenerateButton;



// WEBPACK FOOTER //
// ./source/client/components/reportFileAdmin/generateButton.jsx